import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { AlertPopup } from "../../Asset/common";
import { HttpMethod } from "../../Asset/httpMethod";
import logoImg from "../../Asset/Image/Login/Logo.png";
import "./Login.css";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [emailid, setEmailid] = useState("");
  const [token, setToken] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const rawToken = window.location.search.match(/token=([^&]+)/)?.[1] || "";
    const emailParam = window.location.search.match(/email=([^&]+)/)?.[1] || "";

    setEmailid(decodeURIComponent(emailParam));
    setToken(rawToken);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (!emailid || !token) {
      setError("Invalid Reset Password link");
      return;
    }

    setError("");

    try {
      await HttpMethod.post("/Authorization/Account/ResetPassword", {
        Email: emailid.trim(),
        Password: password,
        ConfirmPassword: confirmPassword,
        Token: token.trim(),
      });

      AlertPopup.SuccessPopup("Password successfully changed!");
      setPassword("");
      setConfirmPassword("");
      navigate("/login");
    } catch (err) {
      setError(err.response?.data || "Something went wrong");
    }
  };

  return (
    <div className="login_page">
      <div className="login_overlay" />
      <div className="login_wrapper">
        <div className="login_side">
          <div className="login_side_inner">
            <img src={logoImg} alt="Logo" className="login_side_logo" />
            <p className="login_side_title">Illuminate Your Moments with SUN DIAM Diamonds</p>
          </div>
        </div>
        <div className="login_card">
          <div className="login_card_header">
            <h2>Reset Password</h2>
            <span className="login_card_subtitle">Create a new password for your account</span>
          </div>
          <form onSubmit={handleSubmit} className="login_form">
            <div className="mb-3 position-relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                className="form-control login_input pe-5"
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter new password"
                autoComplete="new-password"
                required
              />
              <span
                className="password_toggle"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? <IoEyeOff /> : <IoEye />}
              </span>
            </div>

            <div className="mb-3 position-relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                value={confirmPassword}
                className="form-control login_input pe-5"
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
                autoComplete="new-password"
                required
              />
              <span
                className="password_toggle"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
              >
                {showConfirmPassword ? <IoEyeOff /> : <IoEye />}
              </span>
            </div>

            {error && <p className="forgot_message error">{error}</p>}

            <button type="submit" className="login_button btn btn-primary w-100 mb-3">
              Reset Password
            </button>
            <div className="register_line text-center">
              <span>Remember Password?</span>
              <Link to="/login" className="register_link">
                Back to Login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
